import React from 'react';
import { Tooltip } from 'react-tooltip';
import Button from '../Button/button';
interface IdownloadFile {
  onGuideBook: (e: React.FormEvent) => void;
  onFactoryTest: (e: React.FormEvent) => void;
  onScript: (e: React.FormEvent) => void;
}

const Downloadfile: React.FC<IdownloadFile> = ({ onGuideBook, onScript, onFactoryTest }) => {
  return (
    <div className="flex flex-row justify-start gap-6 w-full pb-1 rounded-[5px]">
      <Button
        onclick={onGuideBook}
        className="bg-transparent w-fit font-semibold rounded text-black hover:bg-black hover:text-white py-2 px-6 border"
        data-tooltip-id="book"
        data-tooltip-content="click here to download GuideBook"
        buttonText="User Guide"
      >
        <Tooltip id="book" />
      </Button>
      <Button
        onclick={onScript}
        className="bg-transparent w-fit font-semibold rounded text-black hover:bg-black hover:text-white py-2 px-6 border"
        data-tooltip-id="script"
        data-tooltip-content="click here to download the set-up script"
        buttonText="Download Script"
      >
        <Tooltip id="script" />
      </Button>
      <Button
        onclick={onFactoryTest}
        className="bg-transparent w-fit font-semibold rounded text-black hover:bg-black hover:text-white py-2 px-6 border"
        data-tooltip-id="book"
        data-tooltip-content="click here to download GuideBook"
        buttonText="Factory Test Setup"
      >
        <Tooltip id="Guide book" />
      </Button>
    </div>
  );
};
export default Downloadfile;
